<template>
  <div>
    <form class="row g-3" id="form_id" novalidate @submit.prevent="save">
      <div
        class="justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
      >
        <div class="row">
          <h1 class="h2 text-muted">
            RATING ENGINE / CALCULATORS / {{ head_calculator_name }}
          </h1>
        </div>
        <div class="row" style="float:right">
          <div class="col">
            <button
              type="button"
              class="btn btn-danger"
              data-bs-toggle="modal"
              data-bs-target="#removeModal"
            >
              Remove
            </button>
          </div>
          <div class="col">
            <button
              type="submit"
              class="btn btn-primary"
              style="width: max-content;"
            >
              Save Changes
            </button>
          </div>
        </div>
      </div>
      <div v-if="error" class="alert alert-danger" role="alert">
        {{ reason }}
      </div>

      <div class="col-md-7">
        <label class="form-label">Calculator Name</label>
        <input
          class="form-control"
          v-model="calculator_name"
          disabled
          style="color: grey"
        />
      </div>
      <div class="col-md-5">
        <label class="form-label">Insurer</label>
        <input
          class="form-control"
          v-model="insurer_name"
          disabled
          style="color: grey"
        />
      </div>
      <div class="col-md-12">
        <label class="form-label">Description / Notes</label>
        <textarea
          class="form-control"
          rows="4"
          v-model="calculator_desc"
        ></textarea>
      </div>
      <div class="col-md-7">
        <label for="fullname" class="form-label">Quote Endpoint</label>
        <input
          class="form-control"
          id="fullname"
          v-model="api_route"
          autocomplete="nope"
          required
        />
        <div class="invalid-feedback">
          Quote Endpoint is required!
        </div>
      </div>
      <div class="col-md-7 mb-3">
        <label for="params" class="form-label">Parameters Endpoint</label>
        <input
          class="form-control"
          id="params"
          autocomplete="nope"
          v-model="params_route"
          required
        />
        <div class="invalid-feedback">
          Parameters Endpoint is required!
        </div>
      </div>
    </form>
    <!-- Modal -->
    <div
      class="modal fade"
      id="removeModal"
      tabindex="-1"
      aria-labelledby="removeModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Remove Calculator
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="confirmDelete = ''"
            ></button>
          </div>
          <div class="modal-body">
            <div
              class="alert alert-danger d-flex align-items-center"
              role="alert"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                class="bi bi-exclamation-triangle-fill flex-shrink-0 me-2"
                viewBox="0 0 16 16"
                role="img"
                aria-label="Warning:"
              >
                <path
                  d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                />
              </svg>
              <div>
                Warning: This action cannot be un-done!
              </div>
            </div>
            <div class="row mb-3">
              <label for="confirmDelete" class="col-sm-8 col-form-label"
                >Are you sure you want to remove this calculator? (Type yes to
                confirm)</label
              >
              <div class="col-sm-4">
                <input
                  class="form-control"
                  id="confirmDelete"
                  v-model="confirmDelete"
                  autocomplete="off"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              @click="confirmDelete = ''"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              @click="discard"
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="forceRemoveModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="forceRemoveModalLabel">
              Force Remove Calculator
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="confirmDelete = ''"
            ></button>
          </div>
          <div class="modal-body">
            This calculator has rulesets associated with it. Are you sure you
            still want to remove?
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              @click="confirmDelete = ''"
            >
              No
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              @click="forceRemove"
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from "../../config";
import $ from "jquery";
export default {
  data() {
    return {
      calculator_name: "",
      calculator_desc: "",
      head_calculator_name: "",
      insurers: [],
      inputs: [],
      insurer_id: "",
      insurer_name: "",
      api_route: "",
      error: false,
      confirmDelete: "",
      params_route: "",
      reason: "",
    };
  },
  methods: {
    // async updateInput(input) {
    //   const requestOptions = {
    //     method: "POST",
    //     headers: { "Content-Type": "application/json" },
    //     credentials: "include",
    //     body: JSON.stringify({
    //       data: {
    //         insurer_code_map_id: ruleset.insurer_code_map_id,
    //         quotey_code: $(
    //           "#updatedQuoteyCode" + ruleset.insurer_code_map_id
    //         ).val(),
    //         insurer_code: $(
    //           "#updatedInsurerCode" + ruleset.insurer_code_map_id
    //         ).val(),
    //         quotey_description: $(
    //           "#updatedQuoteyDesc" + ruleset.insurer_code_map_id
    //         ).val(),
    //         insurer_description: $(
    //           "#updatedInsurerDesc" + ruleset.insurer_code_map_id
    //         ).val(),
    //         insurer_id: $(
    //           "#updatedInsurerName" + ruleset.insurer_code_map_id
    //         ).val(),
    //       },
    //     }),
    //   };
    //   const response = await fetch(
    //     config.baseURL + "/update_code_map",
    //     requestOptions
    //   );
    //   const data = await response.json();
    //   console.log(data);
    //   if (data["Added"]) {
    //     this.getDeets();
    //     $("#collapse" + ruleset.insurer_code_map_id).collapse("hide");
    //     this.updateError = false;
    //   } else {
    //     console.log("nope");
    //     this.updateError = true;
    //   }
    // },
    async getDeets() {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            calculator_id: this.$route.params.id,
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/get_single_calculator",
        requestOptions
      );
      const data = await response.json();
      console.log(data);
      if (!data["Accepted"]) this.$router.push("/error");
      this.insurer_id = data["calculator_details"]["insurer_id"];
      this.insurer_name = data["calculator_details"]["insurer_name"];
      this.calculator_name = data["calculator_details"]["calculator_name"];
      this.head_calculator_name = data["calculator_details"]["calculator_name"];
      this.api_route = data["calculator_details"]["api_route"];
      this.params_route = data["calculator_details"]["params_route"];
      this.calculator_desc = data["calculator_details"]["description"];
      this.inputs = data["calculator_inputs"];
    },
    async save() {
      const form = document.getElementById("form_id");
      if (form.checkValidity()) {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            data: {
              calculator_id: parseInt(this.$route.params.id),
              calculator_name: this.calculator_name,
              description: this.calculator_desc,
              api_route: this.api_route,
              params_route: this.params_route,
            },
          }),
        };
        const response = await fetch(
          config.baseURL + "/update_calculator",
          requestOptions
        );
        const data = await response.json();
        console.log(data);
        if (data["Added"]) this.$router.push("/calculators");
        else {
          this.error = true;
          this.reason = data["reason"];
        }
      }
    },
    async discard() {
      if (this.confirmDelete.toLowerCase() === "yes") {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            data: {
              calculator_id: parseInt(this.$route.params.id),
            },
          }),
        };
        const response = await fetch(
          config.baseURL + "/remove_calculator",
          requestOptions
        );
        const data = await response.json();
        console.log(data);
        if (data["Completed"]) this.$router.push("/calculators");
        else $("#forceRemoveModal").modal("show");
      } else {
        this.confirmDelete = "";
      }
    },
    async forceRemove() {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          data: {
            calculator_id: parseInt(this.$route.params.id),
          },
        }),
      };
      const response = await fetch(
        config.baseURL + "/force_remove_calculator",
        requestOptions
      );
      const data = await response.json();
      console.log(data);
      if (data["Completed"]) this.$router.push("/calculators");
    },
  },
  async mounted() {
    this.getDeets();
    // const res = await fetch(config.baseURL + "/get_insurers", {
    //   credentials: "include",
    // });
    // const data = await res.json();
    // this.insurers = data;
    const form = document.getElementById("form_id");
    form.addEventListener(
      "submit",
      function(event) {
        if (!form.checkValidity()) {
          event.preventDefault();
          event.stopPropagation();
        }
        form.classList.add("was-validated");
      },
      false
    );
  },
};
</script>

<style scoped></style>
